import { emperor } from '~/services';
import {
  ApprovalStatusResponse,
  ApproveResponse,
  PendingPartnerBuildingsResponse,
  RejectResponse
} from '~/types/partnerBuildingApproval';

export const getPendingPartnerBuildings = async (
  includeRejected: boolean,
  page: number,
  pageSize: number
): Promise<{ data: PendingPartnerBuildingsResponse }> => {
  return await emperor.get('partner-building-approval', {
    params: { includeRejected, page, pageSize }
  });
};

export const approvePartnerBuildings = async (
  uuids: string[]
): Promise<{ data: ApproveResponse }> => {
  return await emperor.post('partner-building-approval/approve', { uuids });
};

/**
 * Progress of a queued approval batch. The screen calls this with no uuid, so it always
 * reports whichever batch is currently draining — a reload, or opening the page while someone
 * else's approval runs, picks that batch up rather than showing an idle screen.
 */
export const getApprovalStatus = async (
  queueUuid?: string | null
): Promise<{ data: ApprovalStatusResponse }> => {
  return await emperor.get('partner-building-approval/status', {
    params: queueUuid ? { queueUuid } : {}
  });
};

export const rejectPartnerBuildings = async (
  uuids: string[],
  rejectionReason?: string
): Promise<{ data: RejectResponse }> => {
  return await emperor.post('partner-building-approval/reject', {
    uuids,
    rejectionReason: rejectionReason || null
  });
};
